import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd'

class StudentTodoItem extends React.Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (e) {
    this.props.updateTodoCompletion(e.target.checked)
  }

  render () {
    const { completed } = this.props.todoItem
    const classNames = completed
      ? 'todo-completed todo-container'
      : 'todo-container'

    return (
      <div className={classNames}>
        <div className='todo-completion-animation' />
        <div className='todo-index'>{this.props.index + 1}</div>
        <Checkbox
          className='todo-toggle'
          checked={completed}
          onChange={this.handleChange} />
        <div className='todo-title-wrapper'>
          <div className='todo-title'>{this.props.todoItem.title}</div>
        </div>
      </div>
    )
  }
}

StudentTodoItem.propTypes = {
  index: PropTypes.number.isRequired,
  todoItem: PropTypes.shape({
    completed: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  updateTodoCompletion: PropTypes.func.isRequired
}

export default StudentTodoItem



// WEBPACK FOOTER //
// ./src/components/StudentTodoItem.js